// extracted by mini-css-extract-plugin
export default {"tableRow":"List_tableRow__cWNBo","tableCell":"List_tableCell__Xj4TB"};